import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { form, Text, FormGroup, Select } from '../../atoms/Forms'
import { Col, Row } from '../../atoms/Grid'
import Button from '../../atoms/Button'
import Alert from '../../atoms/Alert'
import Loading from '../../atoms/Loading'

import T from '../../../SPRINTA/translate/T'

import * as formatter from '../../../libraries/Formatter'

import * as userData from '../../../utils/userData'

class UpdateProfileFields extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: {},
            error: '',
            status: 'done'
        }

        this.onChange = this.onChange.bind(this)
    }

    onSubmit(e) {
        e.preventDefault()
        let form = {
            ...this.state.form
        }

        if(this.props.fields.indexOf('phone') > -1 && !form['phone']) {
            this.setState({
                error: T.txt('fill_phone')
            })
            return
        }

        if(this.props.fields.indexOf('bday') > -1 && !form['bday']) {
            this.setState({
                error: T.txt('fill_bday')
            })
            return
        }

        if(this.props.fields.indexOf('document') > -1 && !form['document']) {
            this.setState({
                error: T.txt('fill_document')
            })
            return
        }

        if(this.props.fields.indexOf('cpf') > -1 && !form['cpf']) {
            this.setState({
                error: T.txt('fill_cpf')
            })
            return
        }

        if(this.props.fields.indexOf('gender') > -1 && !form['gender']) {
            this.setState({
                error: T.txt('fill_gender')
            })
            return
        }

        this.setState({
            status: 'loading'
        })

        if(this.props.fields.indexOf('bday') > -1) {
            form.bday = formatter.dateFormat('y-m-d', form.bday)
        }


        userData.updateProfile(form)
        .then(resp => {
            let error = ''
            if(resp.errors) {
                error = resp.errors[0].message
            }
            
            this.setState({
                status: 'done',
                error
            })

            if(!resp.errors)
            this.props.onUpdate()
        })
    }

    onChange(e) {
        this.setState( form(this.state.form, e.target) )
    }

  


    render() {
        
        return (
            <form onSubmit={(e) => this.onSubmit(e)}>
                {this.state.error && (
                    <div style={{textAlign: 'left'}}>
                        <Alert type='danger'>
                            {this.state.error}
                        </Alert>
                    </div>
                )}
                <Row>
                    {this.props.fields.indexOf('phone') > -1 && (
                        <Col size={12} float='center'>
                            <FormGroup>
                                <Text
                                    name='phone'
                                    handleChange={this.onChange}
                                    value={this.state.form.phone || ''}
                                    placeholder={T.txt('placeholder_phone')}
                                    mask={T.txt('mask_phone')}
                                />
                            </FormGroup>
                        </Col>
                    )}
                    {this.props.fields.indexOf('bday') > -1 && (
                        <Col size={12} float='center'>
                            <FormGroup>
                                <Text
                                    name='bday'
                                    handleChange={this.onChange}
                                    value={this.state.form.bday || ''}
                                    placeholder={T.txt('placeholder_bday')}
                                    mask={T.txt('mask_date')}
                                />
                            </FormGroup>
                        </Col>
                    )}
                    {this.props.fields.indexOf('document') > -1 && (
                        <Col size={12} float='center'>
                            <FormGroup>
                                <Text
                                    name='document'
                                    handleChange={this.onChange}
                                    value={this.state.form.document || ''}
                                    placeholder={T.txt('placeholder_document')}
                                />
                            </FormGroup>
                        </Col>
                    )}
                    {this.props.fields.indexOf('cpf') > -1 && (
                        <Col size={12} float='center'>
                            <FormGroup>
                                <Text
                                    name='cpf'
                                    handleChange={this.onChange}
                                    value={this.state.form.cpf || ''}
                                    placeholder={T.txt('placeholder_cpf')}
                                    mask='###.###.###-##'
                                />
                            </FormGroup>
                        </Col>
                    )}
                    {this.props.fields.indexOf('gender') > -1 && (
                        <Col size={12} float='center'>
                            <FormGroup>
                                <Select
                                    name='gender'
                                    handleChange={this.onChange}
                                    value={this.state.form.gender || ''}
                                >
                                    <option value=''>{T.txt('gender')}</option>
                                    <option value='m'>{T.txt('male')}</option>
                                    <option value='f'>{T.txt('female')}</option>
                                </Select>
                            </FormGroup>
                        </Col>
                    )}
                </Row>
                
                <Row>
                    <Col size='12' text='right'>
                        <Button
                            style={{
                                float: 'right'
                            }}
                            inline
                            color='orange'
                            disabled={this.state.status === 'loading'}>
                            { this.state.status === 'loading' ? 
                            ( <Loading color='#fff' /> )
                            : T.txt('continue') }
                        </Button>
                    </Col>
                </Row>
                
                
            </form>
        )
    }
}

const mapStateToProps = state => ({})
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfileFields)


// WEBPACK FOOTER //
// ./src/components/forms/UpdateProfileFields/index.js